export const CREATE_FOLDER = "CREATE_FOLDER";
export const DELETE_FOLDER = "DELETE_FOLDER";
export const MOVE_FOLDER = "MOVE_FOLDER";
